import { Component, OnInit } from '@angular/core';
import { ProductsService } from './products.service';
import { ProductModel } from '../../../models/master-data/products.model';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { FormGroup } from '@angular/forms';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { UpdateProductPopupComponent } from './update-product-popup.component';
import { ProductCategoriesModel } from '../../../models/master-data/product-categories.model';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { ManagePriceListService } from '../../centre/manage-price/manage-price-list.service';
import { SharedService } from '../../../shared/services/share.services';

@Component({
    selector: 'products-list',
    templateUrl: 'products-list.component.html',
    providers: [ProductsService, ManagePriceListService]
})

export class ProductsListComponent extends TMBDataTableComponent implements OnInit {
    dataRow = new Array<ProductModel>();
    medicalConditionsVaccinesList: FormGroup;
    filterData = {
        productCategory: null,
        centreId: null,
        productName: '',
        currency: ''
    };
    productCategories = new Array<ProductCategoriesModel>();
    listCurencies:any;
    defaultCurrency: string;

    constructor(
        public dialogService: DialogService,
        public utility: Utility,
        public sharedService: SharedService,
        private managePriceListService: ManagePriceListService,
        private productsService: ProductsService
    ) {
      super(sharedService);
      this.filterData.centreId = localStorage.getItem(AppConstants.localStorage.centreId);
    }

    ngOnInit() {
        this.productsService.getProductCategoryList().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.productCategories = data['list'];
                    // set default filter is first element list
                    if (this.productCategories.length > 0) {
                        this.filterData.productCategory = this.productCategories[0].id;
                        this.setPage({ offset: 0 });
                    }
                }
            }
        );
        this.getCurrency()
        this.getDefaultCurrency()
    }
        getCurrency() {
        this.managePriceListService.getCurrencies(this.filterData.centreId).subscribe(
        result => {
            if (result) {
            const data = result.json();
            this.listCurencies = data;
            }
        }
        );
    
        }


  getDefaultCurrency() {
    this.managePriceListService.getDefaultCurrency(this.filterData.centreId).subscribe(
      resultDefaultCurreny => {
        if (resultDefaultCurreny) {
          this.filterData.currency = resultDefaultCurreny.text();
          this.defaultCurrency = resultDefaultCurreny.text();
        }
      }
    );
  }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        const param = {
            selectedCategory: this.filterData.productCategory === null ? '' : this.filterData.productCategory,
            pageSize: this.page.size,
            currentPage: this.page.pageNumber + 1,
            productName: this.filterData.productName
        };

        this.productsService.getProductByCategory(param).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dataRow = data['list'];
                    this.page.pageNumber = pageInfo.offset;
                    this.page.totalElements = data['totalRecords'];
                }
            },
            error => { }
        );

    }

    onFilter() {

        this.setPage({ offset: 0 });
    }

    onSelectedProductCategory(event) {
        this.filterData.productName = "";
        this.filterData.productCategory = event.target.value;
        this.setPage({ offset: 0 });
    }

    onRemoveItem(id) {
        this.dialogService.openConfirmationDialog({message: AppMessages.product.removeProduct}).subscribe(
            (result) => {
            if (result) {
                this.productsService.removeProduct(id).subscribe(
                    (result) => {
                        if (result) {
                          this.reloadPage(this.page.pageNumber, this.dataRow, true);
                        }
                    }
                );
            }
          });
    }

    addNewProduct() {
      const data = {
        categoryId: this.filterData.productCategory,
        listCurencies: this.listCurencies,
        currencyCode: this.defaultCurrency
      };
        
      this.dialogService.openComponentDialog(UpdateProductPopupComponent, data, { width: '700px' }).subscribe(
        (result) => {
            if (result) {
              this.reloadPage(this.page.pageNumber, this.dataRow);
            }
        }
      );
    }

    onEditItem(id) {
        const data = {
        id: id,
        categoryId: this.filterData.productCategory,
        listCurencies: this.listCurencies,
        currencyCode: this.defaultCurrency
        };
        this.dialogService.openComponentDialog(UpdateProductPopupComponent,
            data, { width: '700px' }).subscribe(
            (result) => {
                if (result) {
                  this.reloadPage(this.page.pageNumber, this.dataRow);
                }
            }
            );
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/products/products-list.component.ts